import {
  PaymentMethod,
  EPaymentProvider,
  EBEPaymentMethodsName,
  CheckoutConfigurations,
} from '../../../../contracts';
import { PaypalButton } from '../../../PaypalButton/PaypalButton';
import { AdyenApplePay } from './components/AdyenApplePay/AdyenApplyPay';
import { AdyenGooglePay } from './components/AdyenGooglePay/AdyenGooglePay';
import { StripeExpressCheckoutWrapper } from '../StripeExpressCheckoutElement/StripeExpressCheckoutElement';

const componentConfig = [
  {
    key: AdyenApplePay.name,
    Component: AdyenApplePay,
    providers: [EPaymentProvider.adyen],
    paymentMethodNames: [EBEPaymentMethodsName.apple],
  },
  {
    key: StripeExpressCheckoutWrapper.name,
    Component: StripeExpressCheckoutWrapper,
    providers: [EPaymentProvider.stripe],
    paymentMethodNames: [
      EBEPaymentMethodsName.link,
      EBEPaymentMethodsName.apple,
      EBEPaymentMethodsName.google,
    ],
  },
  {
    key: AdyenGooglePay.name,
    Component: AdyenGooglePay,
    providers: [EPaymentProvider.adyen],
    paymentMethodNames: [EBEPaymentMethodsName.google],
    shouldHide: (checkoutConfigurations?: CheckoutConfigurations) =>
      Boolean(checkoutConfigurations?.shouldShowGooglePayAsApm),
  },
  {
    key: PaypalButton.name,
    Component: PaypalButton,
    providers: [EPaymentProvider.paypal, EPaymentProvider.braintree],
    paymentMethodNames: [EBEPaymentMethodsName.paypal],
    shouldHide: (checkoutConfigurations?: CheckoutConfigurations) =>
      Boolean(checkoutConfigurations?.shouldShowPayPalAsApm),
  },
];

export const filterExpressComponents = (
  paymentMethods?: PaymentMethod[],
  checkoutConfigurations?: CheckoutConfigurations
) => {
  return componentConfig.filter((componentConfig) =>
    Boolean(
      paymentMethods?.find(
        (pm) =>
          componentConfig.providers.includes(pm.provider as EPaymentProvider) &&
          componentConfig.paymentMethodNames.includes(
            pm.paymentMethodName as EBEPaymentMethodsName
          ) &&
          (!componentConfig.shouldHide || !componentConfig.shouldHide(checkoutConfigurations))
      )
    )
  );
};
